import { Level } from '@config/discount';
import { BrandTypes } from '@lib/domain/order';

const PRICE_UPSELL = {
    [BrandTypes.tiktok]: {
        low: {
            amount: 9.9,
            quantity: 1000,
        },
        medium: {
            amount: 16.9,
            quantity: 2000,
        },
        high: {
            amount: 34.9,
            quantity: 5000,
        },
    },
    [BrandTypes.twitch]: {
        low: {
            amount: 6.9,
            quantity: 200,
        },
        medium: {
            amount: 14.9,
            quantity: 500,
        },
        high: {
            amount: 24.9,
            quantity: 1500,
        },
    },
    [BrandTypes.instagram]: {
        low: {
            amount: 7.9,
            quantity: 250,
        },
        medium: {
            amount: 19.9,
            quantity: 500,
        },
        high: {
            amount: 31.9,
            quantity: 1500,
        },
    },
    [BrandTypes.twitter]: {
        low: {
            amount: 7.9,
            quantity: 200,
        },
        medium: {
            amount: 14.9,
            quantity: 600,
        },
        high: {
            amount: 29.9,
            quantity: 2000,
        },
    },
    [BrandTypes.youtube]: {
        low: {
            amount: 8.9,
            quantity: 100,
        },
        medium: {
            amount: 14.9,
            quantity: 200,
        },
        high: {
            amount: 24.9,
            quantity: 400,
        },
    },
};

export const getUpsellLevel = (total: number): Level => {
    if (total < 15) {
        return Level.low;
    }
    if (total >= 15 && total <= 40) {
        return Level.medium;
    }
    return Level.high;
};
